import { HttpClient } from '../utils/httpClient';

const PATH = {
    getRevenue: '/root/revenue-calculator',
};

const getRevenue = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getRevenue}`, { params }).then(callback).catch(error).finally(next);
};

export const RootRevenueCalculatorService = {
    getRevenue,
};
